interface SidebarChevronIconProps {
  direction: 'left' | 'right';
}

function SidebarChevronIcon({ direction }: SidebarChevronIconProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {direction === 'left' ? (
        <path
          d="M11.25 13.5L6.75 9L11.25 4.5"
          stroke="#536171"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M6.75 4.5L11.25 9L6.75 13.5"
          stroke="#536171"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}

export default SidebarChevronIcon;
